/**
 * @file
 */

export default {
    initProcessState: true,
    initSelectProcess: [],
    initFollowInfo: {},
    initAuthorInfo: {},
    initIssueFollowInfo: {},
    initReply: false,
    initSelectedTime: null,
    filterQuery: {}
};
